import { WelcomeResponse, UserData } from '../interfaces/Welcome';
import { RegisterResponse } from '../interfaces/Register';
import apiService from './api.service';

class WelcomeService {
  // Registrazione utente con profilo completo (integrazione di register + profile update)
  async registerUserWithProfile(data: UserData): Promise<RegisterResponse> {
    try {
      // Prepara il payload per la registrazione con tutti i dati del profilo
      const registerPayload = {
        email: data.email,
        password: data.password,
        sponsor_code: data.sponsor_code || null,
        first_name: data.first_name,
        last_name: data.last_name,
        birth_date: data.birth_date,
        residence: data.residence, // Usa direttamente la residenza già geocodificata
        interested_to: data.interested_to,
        phone_number: data.phone_number
      };

      // Chiamata unica per registrazione + profilo
      const response = await apiService.post<RegisterResponse>('/users/register/', registerPayload);

      if (response.data.token) {
        const user = response.data.user;
        const userId = user.id;
        const accessToken = response.data.token;

        // Salva i dati di autenticazione in sessionStorage
        sessionStorage.setItem("userId", userId.toString());
        sessionStorage.setItem("authToken", accessToken.access);
      }

      return response.data;
    } catch (error) {
      console.error("Errore durante la registrazione con profilo:", error);
      throw error;
    }
  }

  // Completamento del processo di onboarding (registrazione + brevo + link attivazione)
  async completeOnboarding(data: UserData): Promise<WelcomeResponse> {
    try {
      await this.registerUserWithProfile(data);

      await this.handleBrevoNewsletter(data.email);

      return { success: true };
    } catch (error) {
      console.error("Errore durante il completamento dell'onboarding:", error);
      throw error;
    }
  }

  // Gestione newsletter Brevo (spostato da RegisterForm)
  async handleBrevoNewsletter(email: string): Promise<void> {
    const BREVO_API_KEY = "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";
    const LIST_ID = 12;

    const createContactOptions = {
      method: "POST",
      headers: {
        accept: "application/json",
        "content-type": "application/json",
        "api-key": BREVO_API_KEY,
      },
      body: JSON.stringify({
        email: email,
        emailBlacklisted: false,
        smsBlacklisted: false,
        listIds: [LIST_ID],
        updateEnabled: false,
      }),
    };

    const updateContactOptions = {
      method: "POST",
      headers: {
        accept: "application/json",
        "content-type": "application/json",
        "api-key": BREVO_API_KEY,
      },
      body: JSON.stringify({ emails: [email] }),
    };

    try {
      const response = await fetch("https://api.brevo.com/v3/contacts", createContactOptions);
      const result = await response.json();

      if (result.code === "duplicate_parameter") {
        // L'utente esiste già, aggiungilo alla lista
        await fetch(
          `https://api.brevo.com/v3/contacts/lists/${LIST_ID}/contacts/add`,
          updateContactOptions
        );
      }
    } catch (error) {
      console.error("Errore nella gestione newsletter:", error);
      // Non blocchiamo la registrazione se fallisce la newsletter
    }
  }
}

// Esporta istanza singleton
const welcomeService = new WelcomeService();
export default welcomeService;
